import { Link } from "react-router-dom";

export default function Logo({ big = false }) {
    return (
        <Link to="/" data-testid="logo-home-link" aria-label="Zur Startseite" className="flex items-center group shrink-0">
            <img
                src="/logo_transparent.png"
                alt="Müller Satelliten- und Antennentechnik GmbH"
                data-testid="logo-image"
                className={`${big ? "h-16" : "h-14"} w-auto transition-opacity duration-300 group-hover:opacity-80`}
            />
        </Link>
    );
}
